"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatUrl = void 0;
const formatUrl = (value) => {
    const url = new URL(value);
    // Remove last slash from pathname
    return `${url.protocol}//${url.hostname}${url.pathname.replace(/\/$/, '')}${url.search}`;
};
exports.formatUrl = formatUrl;
//# sourceMappingURL=formatUrl.js.map